import { render, staticRenderFns } from "./StartPanel.vue?vue&type=template&id=c6a8aef8&scoped=true&"
import script from "./StartPanel.vue?vue&type=script&lang=js&"
export * from "./StartPanel.vue?vue&type=script&lang=js&"
import style0 from "./StartPanel.vue?vue&type=style&index=0&id=c6a8aef8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a8aef8",
  null
  
)

export default component.exports